import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AdminContext = createContext(null);

export const AdminProvider = ({ children }) => {
  const [admin, setAdmin] = useState(undefined); // undefined=loading, null=guest, obj=admin
  const [token, setToken] = useState(localStorage.getItem("ttd_admin_token"));

  useEffect(() => {
    const check = async () => {
      if (!token) { setAdmin(null); return; }
      try {
        const { data } = await api.get("/auth/me");
        setAdmin(data);
      } catch {
        localStorage.removeItem("ttd_admin_token");
        setAdmin(null);
      }
    };
    check();
  }, [token]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("ttd_admin_token", data.token);
    setToken(data.token);
    setAdmin(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("ttd_admin_token");
    setToken(null);
    setAdmin(null);
  };

  return (
    <AdminContext.Provider value={{ admin, login, logout }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => useContext(AdminContext);
